export const DEALER_PORTAL_URL = process.env.REACT_APP_DEALER_PORTAL_URL;
export const DEALER_PORTAL_X_API_KEY =
    process.env.REACT_APP_DEALER_PORTAL_X_API_KEY;
export const COGNITO_TOKEN_NAME = 'cognitoToken';
export const PERMISSIONS_TOKEN_NAME = 'permissionsToken';
export const USER_NAME = 'username';
export const FULL_NAME = 'fullName';
export const DEALER_COUNTRY_NAME = 'dealerCountry';
export const PERMISSIONS_NAME = 'permissions';
export const PERMISSIONS_DEALER = 'permissionsDealers';
export const ASSOCIATIONS_NAME = 'associations';
export const DEFAULTDEALER_NAME = 'defaultDealer';
export const RECAPTCHA_SITE_KEY =
    process.env.REACT_APP_RECAPTCHA_SITE_KEY ?? '';
export const TERMDATE_ITEM_NAME = 'creditTermDate';
export const DISTRICTS_NAME = 'districts';
export const ACCESS_USER_NAME = 'accessUsr';
export const SELECTED_DISTRICT = 'selectedDistrict';
export const SELECTED_DEALER = 'selectedDealer';
export const GET_DEALER_GROUP_STATE = 'dealerGroupState';
export const US_PAYOFF_QUOTE_VENDOR_URL_AU =
    process.env.REACT_APP_US_PAYOFF_QUOTE_VENDOR_URL_AU ?? '';
export const US_PAYOFF_QUOTE_VENDOR_URL_VW =
    process.env.REACT_APP_US_PAYOFF_QUOTE_VENDOR_URL_VW ?? '';
export const PARTYID_NAME = 'partyId';
export const ACTIVE_NEWS_SESSION_NAME = 'activeNews';
export const DISMISSED_ACTIVE_NEWS_SESSION_NAME = 'dismissedActiveNews';
